import React from 'react'
import { MapContainer, TileLayer, useMap, Marker, Popup, } from 'react-leaflet'
import 'leaflet/dist/leaflet.css';

export const PolygonMap = () => {
  return (
    // <MapContainer center={[51.505, -0.09]} zoom={13} scrollWheelZoom={false}>
    <MapContainer center={[51.505, -0.09]}
      zoom={13}
      scrollWheelZoom={false}
      style={{ height: "400px", width: "100%" }}>
      <TileLayer
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />
      <Marker position={[51.505, -0.09]}>
        <Popup>
          A pretty CSS3 popup. <br /> Easily customizable.
        </Popup>
      </Marker>
    </MapContainer>
  )
}
